/**
 * Model for Products
 *
 */
export class ProductsModel {
	id?: string;
	title?: string;
	alternativeName?: string;
	active?: boolean;
	origin?: string;
	description?: string;
	inspection?: InspectionConfiguration;
	acuity?: TrackingSystemConfigurationInfo;
	nexsys?: NexsysIntegrationConfig;
	appScope?: AppScopeTrakingConfigurationInfo;
	insideMaps?: InsideMapsTrakingConfigurationInfo;
	valutrust?: IntegrationConfig;
	xpanse?: IntegrationConfig;
	fnc?: IntegrationConfig;
	integration?: ClassValuationIntegration;
	createdBy?: UserInfo;
	created?: string;
	updatedBy?: UserInfo;
	updated?: string;
	subProductConfiguration?: SubProduct;
	licensingServiceSetting?: LicensingServiceSetting;
	channel?: string;
	productType?: string;
	valuationType?: string;
	isOrganizationLevel?: boolean;
	isUAD36Product?: boolean;
	enableHandheld?: boolean;

	constructor() {
		this.active = true;
		this.title = '';
		this.alternativeName = '';
		this.description = '';
		this.origin = null;
		this.channel = null;
		this.productType = '';
		this.valuationType = '';
		this.inspection = new InspectionConfiguration();
		this.insideMaps = new InsideMapsTrakingConfigurationInfo();
		this.appScope = new AppScopeTrakingConfigurationInfo();
		this.nexsys = new NexsysIntegrationConfig();
		this.acuity = new TrackingSystemConfigurationInfo();
		this.valutrust = new IntegrationConfig();
		this.xpanse = new IntegrationConfig();
		this.fnc = new IntegrationConfig();
		this.integration = new ClassValuationIntegration();
		this.subProductConfiguration = new SubProduct();
		this.licensingServiceSetting = new LicensingServiceSetting();
		this.isOrganizationLevel = false;
		this.isUAD36Product = false;
		this.enableHandheld = false;
	}
}

export class InspectionConfiguration {
	enabled?: boolean;
	schema?: string;
	gsePreference?: string;
	keepInspection?: boolean;
	softwareCollector?: string;
	gseFungible?: boolean;
	disableFREDDIESubmition?: boolean;
	disableFNMASubmition?: boolean;
	useUPD?: boolean;
	injectImagesIntoForm?: boolean;

	constructor() {
		this.enabled = false;
		this.schema = null;
		this.gsePreference = null;
		this.keepInspection = false;
		this.softwareCollector = null;
		this.gseFungible = false;
		this.disableFREDDIESubmition = false;
		this.disableFNMASubmition = false;
		this.useUPD = false;
		this.injectImagesIntoForm = false;
	}
}

export class TrackingSystemConfigurationInfo {
	integrationId?: string;
	name?: string;
	enabled?: boolean;
	productId?: string;
	productName?: string;
	disableCommunications: boolean;
	isFhaProduct?: boolean;
	productAssetsId?: string;
	productAssetDescription?: string;
	defaultFhaNumber?: string;
	isDefaultProduct?: boolean;
	orderAttribute?: Array<string>;
	isOrderRentSchedule?: boolean;
	isOrderIncomeStatement?: boolean;
	bpoProduct?: boolean;
	bpoLinkTrigger?: string;
	is3dProduct: boolean;
	autoCompleteScopeOrderOption?: AutoCompleteScopeOrder;
	notifyAppscopeAcuityOrderEscalated?: boolean;
	invoice?: boolean;
	instance?: string;
	reportVisibleToVendor?: boolean;

	constructor() {
		this.autoCompleteScopeOrderOption = new AutoCompleteScopeOrder();
		this.notifyAppscopeAcuityOrderEscalated = false;
		this.enabled = false;
		this.productId = null;
		this.productName = null;
		this.productAssetsId = null;
		this.productAssetDescription = null;
		this.bpoProduct = false;
		this.bpoLinkTrigger = null;
		this.is3dProduct = false;
		this.disableCommunications = false;
		this.instance = null;
		this.invoice = false;
		this.reportVisibleToVendor = false;
	}
}

export class IntegrationConfig {
	enabled?: boolean;
	productId?: string;
	productName?: string;
	isDefaultProduct?: boolean;
	isOrderIncomeStatement?: boolean;
	isOrderRentSchedule?: boolean;
	isFhaProduct?: boolean;
	defaultFhaNumber?: string;
	constructor() {
		this.enabled = false;
		this.productId = null;
		this.productName = null;
		this.isDefaultProduct = false;
		this.isOrderIncomeStatement = false;
		this.isOrderRentSchedule = false;
		this.isFhaProduct = false;
		this.defaultFhaNumber = null;
	}
}

export class NexsysIntegrationConfig extends IntegrationConfig {
	orderAttribute?: Array<string>;
	constructor() {
		super();
		this.orderAttribute = null;
	}
}

export class ClassValuationIntegration extends IntegrationConfig{
	integrationName?: string;
	integrationId?: string;
	orderAttribute?: Array<string>;
	name?: string;

	constructor() {
		super();
		this.integrationId = null;
		this.orderAttribute = null;
		this.name = null;
	}
}

export class AutoCompleteScopeOrder {
	autoComplete?: boolean;
	autoCompleteMilestoneTrigger?: string;
	uploadDocuments?: boolean;
	uploadDocumentsMilestone?: string;
	documents?: Array<DocumentScopeOrder>;

	constructor() {
		this.autoComplete = false;
		this.autoCompleteMilestoneTrigger = null;
		this.uploadDocuments = false;
		this.uploadDocumentsMilestone = null;
		this.documents = [];
	}
}

class DocumentScopeOrder {
	documentSource?: string;
	documentType?: string;
	isFinalDocument?: boolean;
}

export class AppScopeTrakingConfigurationInfo {
	enabled?: boolean;
	jobId?: string;
	jobName?: string;
	disableCommunications?: boolean;
	enqueueCommunications?: boolean;
	borrowerEmailToComments?: boolean;
	creationTrigger?: string;
	creationStatusTrigger?: string;
	productAssetsId?: string;
	productAssetDescription?: string;
	associatedOrderProductName?: string;
	associatedOrderProductType?: string;
	enableAcuityFileSincronization?: boolean;
	invoice?: boolean;

	constructor() {
		this.enabled = false;
		this.jobId = null;
		this.jobName = null;
		this.invoice = false;
		this.creationTrigger = 'IncomingOrder';
		this.productAssetsId = null;
		this.productAssetDescription = null;
		this.disableCommunications = false;
		this.enqueueCommunications = false;
		this.borrowerEmailToComments = false;
		this.creationStatusTrigger = null;
		this.associatedOrderProductType = null;
		this.associatedOrderProductName = null;
		this.enableAcuityFileSincronization = false;
	}
}

export class InsideMapsTrakingConfigurationInfo {
	enabled?: boolean;
	insideMapsName?: string;
	insideMapsId?: string;
	insideMapsFee?: number;
	sendListingLink?: boolean;
	sendPropertyReportPageLink?: boolean;

	constructor() {
		this.enabled = false;
		this.insideMapsName = null;
		this.insideMapsId = null;
		this.insideMapsFee = null;
		this.sendListingLink = false;
		this.sendPropertyReportPageLink = false;
	}
}

export class UserInfo {
	id?: string;
	firstName?: string;
	lastName?: string;
}

export class SubProduct {
	products?: Array<SubProductInfo>;

	constructor() {
		this.products = [
			new SubProductInfo(),
			new SubProductInfo()
		];
	}
}

export class SubProductInfo {
	id?: string;
	name?: string;
	subProductFee?: number;
	creationTrigger?: string;
	creationStatusTrigger?: string;
	hybridMode?: boolean;

	constructor() {
		this.id = null;
		this.name = null;
		this.subProductFee = null;
		this.creationTrigger = null;
		this.creationStatusTrigger = null;
		this.hybridMode = false;
	}
}

export class TrakingListModel {
	id?: string;
	title?: string;
}

class AcuityCreationSetting {
	acuityProductId: string;
	acuityProductName: string;
	creationTrigger: string;

	constructor() {
		this.acuityProductId = '';
		this.acuityProductName = '';
		this.creationTrigger = 'IncomingOrder'
	}
}

export class LineOfBussiness {
	id?: string;
	name?: string;
}

export class InvoiceOption {
	anable?: boolean;
}

export class ProductsData {
	id?: string;
	name?: string;
	subProductFee?: string;
	creationTrigger?: string;

	constructor() {
		this.id = null
		this.name = null;
		this.subProductFee = '0';
		this.creationTrigger = 'Manage3DScan';
	}
}

class SubProductConfiguration {
	products: Array<ProductsData>;

	constructor() {
		const productsData1 = new ProductsData();
		const productsData2 = new ProductsData();

		this.products = [
			productsData1,
			productsData2
		];
	}
}

export class LicensingServiceSetting {
	enabled: boolean;
	acuityCreationSetting: AcuityCreationSetting;
	subProductConfiguration: SubProductConfiguration;

	constructor() {
		this.enabled = false;
		this.acuityCreationSetting = new AcuityCreationSetting();
		this.subProductConfiguration = new SubProductConfiguration();
	}
}


export class ListOptions {
	id?: string;
	name?: string;
}
